// extracted by mini-css-extract-plugin
module.exports = {"clickable":"styles_clickable__BJn35","large":"styles_large__4raE5"};